import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3991aca7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tabs-content" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Contact us", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, " Do you want to inform something else ? ", -1))
const _hoisted_7 = {
  key: 0,
  class: "error-text"
}
const _hoisted_8 = {
  key: 1,
  class: "error-text"
}
const _hoisted_9 = { class: "d-flex-gap" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "tabs-content" }
const _hoisted_12 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_13 = { class: "form-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Contact us", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, " Do you want to inform something else ? ", -1))
const _hoisted_16 = {
  key: 0,
  class: "error-text"
}
const _hoisted_17 = {
  key: 1,
  class: "error-text"
}
const _hoisted_18 = { class: "d-flex-gap" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "tabs-content" }
const _hoisted_21 = { class: "form-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "More request", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Need more requests? Book a free demo or contact us through our form for assistance.", -1))
const _hoisted_24 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_ctx.active_nav === 'choice' && (_ctx.userInfo?.advertiser?.is_premium == true || _ctx.isTawaAgencyUser == true))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Spinner)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.subject) = $event)),
              class: _normalizeClass(["text-input", { 'invalid-field': _ctx.errors?.subject?.length > 0 }]),
              placeholder: "Subject*",
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate('subject')))
            }, null, 34), [
              [_vModelText, _ctx.formData.subject]
            ]),
            (_ctx.errors?.subject?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errors?.subject), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.body) = $event)),
              class: _normalizeClass(["text-input", { 'invalid-field': _ctx.errors?.body?.length > 0 }]),
              placeholder: "Mail body*",
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validate('body')))
            }, null, 34), [
              [_vModelText, _ctx.formData.body]
            ]),
            (_ctx.errors?.body?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errors?.body), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
              }, "Send message"),
              _createElementVNode("button", {
                class: "btn-black",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancel()))
              }, "Cancel")
            ])
          ])
        ])
      ]))
    : (_ctx.active_nav === 'contact' && (_ctx.userInfo?.advertiser?.is_premium !== true && _ctx.isTawaAgencyUser !== true))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_Spinner)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.subject) = $event)),
                class: _normalizeClass(["text-input", { 'invalid-field': _ctx.errors?.subject?.length > 0 }]),
                placeholder: "Subject*",
                onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validate('subject')))
              }, null, 34), [
                [_vModelText, _ctx.formData.subject]
              ]),
              (_ctx.errors?.subject?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errors?.subject), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.body) = $event)),
                class: _normalizeClass(["text-input", { 'invalid-field': _ctx.errors?.body?.length > 0 }]),
                placeholder: "Mail body*",
                onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validate('body')))
              }, null, 34), [
                [_vModelText, _ctx.formData.body]
              ]),
              (_ctx.errors?.body?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errors?.body), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submit()))
                }, "Send message"),
                _createElementVNode("button", {
                  class: "btn-black",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancel()))
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "btn-more-request",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.change_active_nav()))
                }, "Contact us"),
                _createElementVNode("button", {
                  class: "btn-demo",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToBookDemo()))
                }, "Book a demo")
              ])
            ])
          ])
        ]))
}